import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import { history } from '../store'

import { fetchOperator } from '../actions/operators'
import AssignedRulesList from '../components/AssignedRulesList'
import OperatorEditForm from '../forms/OperatorEditForm'
import '../styles/OperatorDetailsView.css'

class OperatorDetailsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showEditModal: false
    }

    this.refreshOperator = this.refreshOperator.bind(this)
    this.toggleEditModal = this.toggleEditModal.bind(this)
  }

  componentDidMount() {
    this.props.fetchOperator(this.props.match.params.id);
  }

  refreshOperator() {
    this.props.fetchOperator(this.props.match.params.id);
  }

  toggleEditModal() {
    this.setState({ showEditModal: !this.state.showEditModal })
  }

  goToCalendar(id, e) {
    e.stopPropagation();
    history.push(`/calendars/${id}`)
  }

  getInvoiceName(type) {
    switch (type) {
      case 'Invoice': return 'Factura'
      case 'Note': return 'Albarán'
      case 'Free': return 'No Contable'
    }
  }

  render() {
    const { operator, error, loading, auth, submitting, role, type, category } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!operator || loading) {
      return <LoadingProgress />
    }

    const infoRow = (label, value, extraClass = '') => (
      <div className="operator-info-row">
        <span className="operator-info-label">{label}</span>
        <span className={`operator-info-value${extraClass ? ` ${extraClass}` : ''}`}>{value}</span>
      </div>
    )

    return (
      <div className="operator-details-view">
        {/* Header */}
        <div className="operator-details-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-handshake"></i>
                AGREGADOR <span className="op-name">{operator.Name}</span>
                <span className={`operator-details-badge ${operator.Blocked ? 'danger' : 'success'}`}>
                  <i className={`fas ${operator.Blocked ? 'fa-ban' : 'fa-check'}`}></i>
                  {operator.Blocked ? 'Venta deshabilitada' : 'Venta habilitada'}
                </span>
              </h1>
            </div>
            {((role === 'ADMIN' && (type === 'MASTER')) || category === 'BAQUEIRA') &&
              <div className="header-actions">
                <button type="button" className="operator-details-btn primary" onClick={this.toggleEditModal}>
                  <i className="fas fa-edit"></i>
                  Editar
                </button>
              </div>
            }
          </div>
        </div>

        {/* Cards */}
        <div className="operator-details-grid">
          <div className="operator-details-card">
            <div className="operator-card-header">
              <i className="fas fa-sliders-h mr-2"></i>
              Configuración
            </div>
            <div className="operator-card-body">
              {infoRow('Venta habilitada', operator.Blocked ? 'NO' : 'SI')}
              {infoRow('Modelo de facturación', this.getInvoiceName(operator.InvoiceType))}
              {infoRow('Canal Propio Baqueira', operator.External ? 'SI' : 'NO')}
              {infoRow('Comisión', operator.Comission)}
              {infoRow('NIF/CIF', operator.Nif)}
              {infoRow('Dirección', operator.Address)}
              {infoRow('País', operator.Country)}
            </div>
          </div>

          <div className="operator-details-col">
            <div className="operator-details-card">
              <div className="operator-card-header">
                <i className="fas fa-user mr-2"></i>
                Credenciales API
              </div>
              <div className="operator-card-body">
                {infoRow('Bearer Token', operator._id, 'token-value')}
              </div>
            </div>
            <div className="operator-details-card">
              <div className="operator-card-header">
                <i className="fas fa-calendar mr-2"></i>
                Calendario de precios
              </div>
              <div className="operator-card-body">
                {infoRow('Calendario', operator.Calendar ? operator.Calendar.Name : 'None')}
              </div>
            </div>
          </div>

          <div className="operator-details-card">
            <div className="operator-card-header">
              <i className="fas fa-pencil-ruler mr-2"></i>
              Reglas de negocio
            </div>
            <div className="operator-card-body">
              <AssignedRulesList Rules={operator.BusinessRules} />
            </div>
          </div>
        </div>

        {/* Edit Operator Modal */}
        <Modal isOpen={this.state.showEditModal} toggle={this.toggleEditModal} size="lg" className="op-modal">
          <ModalHeader toggle={this.toggleEditModal}>
            <span className="text-vw-dark">EDITAR </span>
            <span className="text-vw-light">AGREGADOR</span>
          </ModalHeader>
          <ModalBody>
            <OperatorEditForm
              isModal={true}
              closeModal={this.toggleEditModal}
              refreshOperator={this.refreshOperator}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  operator: state.operators.operator,
  loading: state.operators.loading,
  error: state.operators.error,
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  category: state.auth.category
});

const mapDispatchToProps = dispatch => ({
  fetchOperator: bindActionCreators(fetchOperator, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(OperatorDetailsView);
